import { render, staticRenderFns } from "./AlertasIncidencias.vue?vue&type=template&id=2870bb57&scoped=true&"
import script from "./AlertasIncidencias.vue?vue&type=script&lang=js&"
export * from "./AlertasIncidencias.vue?vue&type=script&lang=js&"
import style0 from "./AlertasIncidencias.vue?vue&type=style&index=0&id=2870bb57&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2870bb57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBadge,VBtn,VIcon,VList,VListItem,VListItemContent,VMenu,VSpacer,VSubheader,VTooltip})
